import React, { Component } from 'react';
import { connect } from "react-redux";
import store from '../../store/configureStore';
import { Businesses } from '../../config/Helper';
import { changeActiveItemAction } from '../../actions/navAction';
import { changeTopBannerAction } from '../../actions/topBannerAction';
import AgencyMain from './AgencyMain';
import ScrollToTop from '../home/ScrollToTop/ScrollToTop';

class Agency extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: props.match.params.id,
        }
    }

    componentWillMount() {
        store.dispatch(changeTopBannerAction({
            page: 'agency_detail',
            showSearch: false,
            isHome: false
        }));
    }

    componentDidMount() {
        window.scrollTop('#top_banner');
        store.dispatch(changeActiveItemAction(Businesses.indexOf('about')));
    }

    componentWillUnmount() {

    }

    componentWillReceiveProps(newProps) {
        this.setState({ id: newProps.match.params.id });
    }

    componentDidUpdate() {

    }


    render() {
        return (
            <div>
                <AgencyMain id={this.state.id} />
                <ScrollToTop />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        language: state.language
    };
}

export default connect(mapStateToProps)(Agency);